<template>
  <div>
    <item-desc :fields="fields" :data="data" :label-width="150">

      <template slot="status" slot-scope="{ field }">
        <Tag checkable color="primary" v-if="field === 0">正在报名</Tag>
        <Tag checkable color="primary" v-else-if="field === 1">报名失败</Tag>
        <Tag checkable color="success" v-else-if="field === 2">报名成功</Tag>
        <Tag checkable color="warning" v-else-if="field === 3">已失效</Tag>
      </template>
      <template slot="type" slot-scope="{ field }">
        <Tag checkable color="primary" v-if="field === 10">参观登记</Tag>
        <Tag checkable color="primary" v-else-if="field === 11">参展登记</Tag>
        <Tag checkable color="success" v-else-if="field === 20">参会登记</Tag>
        <Tag checkable color="warning" v-else-if="field === 21">广告演讲</Tag>
      </template>
    </item-desc>
  </div>
</template>

<script>

import pageTable from '../../../components/pageTable/index'
import itemDesc from '../../../components/item-desc/index'
import { getMemberOrderDetail } from '../../../api/activity'
export default {
  name: 'order-detail',
  components: { pageTable, itemDesc },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fields: [
        { key: 'nickname', label: '昵称', type: 'text', clearable: true, readonly: 'readonly', span: 12 },
        { key: 'avatar', label: '头像', type: 'avatar', clearable: true, readonly: 'readonly', span: 12 },
        { key: 'realname', label: '姓名', type: 'text', span: 12 },
        { key: 'id_card', label: '身份证号', type: 'text', span: 12 },
        { key: 'total_fee', label: '支付金额', type: 'text', span: 12 },
        { key: 'mobile', label: '手机号', type: 'text', span: 12 },
        { key: 'email', label: '邮箱', type: 'text', span: 12 },
        { key: 'position', label: '职位', type: 'text', span: 12 },
        { key: 'company_name', label: '公司名称', type: 'text', span: 12 },
        { key: 'company_product', label: '主营产品', type: 'text', span: 12 },
        { key: 'province', label: '省份', type: 'text', span: 12 },
        { key: 'city', label: '城市', type: 'text', span: 12 },
        { key: 'area', label: '地区', type: 'text', span: 12 },
        { key: 'company_address', label: '详细地址', type: 'text', span: 12 },
        { key: 'status', label: '报名状态', type: 'slot', span: 12 },
        { key: 'type', label: '活动类型', type: 'slot', span: 12 },
        { key: 'qrcode_str', label: '二维码数值', type: 'text', span: 12 },
        { key: 'create_time', label: '报名时间', type: 'text', span: 12 },
        { key: 'paid_at', label: '支付时间', type: 'text', span: 12 }
      ],
      data: {

      },
      tableLoading: false
    }
  },
  watch: {
    id (val, old) {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.tableLoading = true
      getMemberOrderDetail({ order_no: this.id }).then(({ data }) => {
        this.data = data
      }).finally(() => {
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
